export const DisplayTimezoneOffset = (offset: number) => {
  const isZeroOrPositive = offset >= 0;
  const offsetAbs = Math.abs(offset);
  const hours = Math.floor(offsetAbs / 60);
  const minutes = offsetAbs % 60;

  const hh = Math.floor(hours / 10) === 0 ? `0${hours}` : hours.toString();
  const mm = Math.floor(minutes / 10) === 0 ? `0${minutes}` : minutes.toString();

  return `${isZeroOrPositive ? "+" : "-"}${hh}:${mm}`;
}

/**
 * Formats timezone offset as "UTC+1" (no minutes) or "UTC+5:30" (with minutes)
 * @param offset - timezone offset in minutes
 * @returns formatted string like "UTC+1" or "UTC+5:30"
 */
export const formatTimezoneOffsetUTC = (offset: number): string => {
  const isZeroOrPositive = offset >= 0;
  const offsetAbs = Math.abs(offset);
  const hours = Math.floor(offsetAbs / 60);
  const minutes = offsetAbs % 60;
  
  const sign = isZeroOrPositive ? "+" : "-";
  const hh = hours.toString();
  
  // If no minutes, show "UTC+1", otherwise show "UTC+5:30"
  if (minutes === 0) {
    return `UTC${sign}${hh}`;
  } else {
    const mm = minutes.toString().padStart(2, '0');
    return `UTC${sign}${hh}:${mm}`;
  }
};